module.exports = __webpack_public_path__ + "static/img/1_0044.dff8cd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0044.jpg
// module id = PqkL
// module chunks = 0